import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { useImmobiliPortalAuth } from "../context/ImmobiliPortalAuthContext";

export default function ImmobiliPortalChangePasswordDialog({ open }) {
  const { changePassword } = useImmobiliPortalAuth();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (newPassword !== confirmPassword) {
      setError("Le password non coincidono");
      return;
    }
    setSubmitting(true);
    try {
      await changePassword(newPassword, confirmPassword);
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      setError(err.response?.data?.detail || "Impossibile aggiornare la password");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/70"
      role="dialog"
      aria-modal="true"
      aria-labelledby="portal-change-password-title"
    >
      <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-6 shadow-2xl">
        <div className="w-12 h-12 rounded-xl bg-blue-100 flex items-center justify-center mb-4">
          <Lock className="w-6 h-6 text-[#4068E8]" />
        </div>
        <h2 id="portal-change-password-title" className="text-lg font-semibold text-slate-900">
          Scegli la tua password
        </h2>
        <p className="text-sm text-slate-600 mt-2 mb-5">
          Per motivi di sicurezza devi impostare una nuova password personale prima di usare il portale.
          La password temporanea ricevuta via email non sarà più valida dopo questo passaggio.
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="portal-new-password">Nuova password</Label>
            <Input
              id="portal-new-password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              autoComplete="new-password"
              autoFocus
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="portal-confirm-password">Conferma password</Label>
            <Input
              id="portal-confirm-password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              autoComplete="new-password"
            />
          </div>
          <p className="text-xs text-slate-500">
            Minimo 10 caratteri, con maiuscola, minuscola, numero e carattere speciale (@$!%*?&._-#).
          </p>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <Button type="submit" className="w-full bg-[#4068E8] hover:bg-[#3557D4]" disabled={submitting}>
            {submitting ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Salvataggio...
              </>
            ) : (
              "Imposta password e continua"
            )}
          </Button>
        </form>
      </div>
    </div>
  );
}
